export default __webpack_public_path__ + "static/media/undraw_Work_chat_re_qes4.1e0d1743.svg";